export const CLAIM_PROJECT_OTHER_FIELDS = [];